import { Link } from "react-router-dom";

export const Wordmark = ({ light = false, size = "md" }) => {
  const big = size === "lg";
  return (
    <Link to="/" data-testid="brand-wordmark" className="inline-flex flex-col leading-none group">
      <span
        className={`font-serif tracking-[0.28em] uppercase ${big ? "text-4xl" : "text-[22px]"} ${light ? "text-white" : "text-[#0A0A0A]"}`}
      >
        Cassia
      </span>
      <span
        className={`uppercase tracking-[0.42em] ${big ? "text-[11px] mt-2" : "text-[8.5px] mt-1"} font-semibold ${light ? "text-white/60" : "text-[#737373]"} transition-colors duration-300 group-hover:text-[#B4A38E]`}
      >
        Concept
      </span>
    </Link>
  );
};
